import { TRootState } from "Redux/Reducers";

export const getLastEventCategoryId = (state: TRootState) => state.eventCategory.lastUpdateId;
